import {
  DropdownButton,
  DropdownButtonContext,
  List,
} from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ampli } from 'lib-shared-tracking';
import React, { memo, useCallback } from 'react';

import { TimelineIcon } from '../../timelineIcon';
import { TimelineConversationType } from '../timelineComponent';

import styles from './index.module.scss';
import { TimelineItemRow } from './timelineItemRow/timelineItemRow';

type TimelineItemProps = {
  /** Extra classnames */
  className?: string;
  /** Conversations array */
  conversations: Array<TimelineConversationType>;
  /** Status of the item (most important among conversations) */
  status: string;
  /** Is this the current item? */
  isCurrent?: boolean;
  /** On select callback */
  onConversationSelect: (csid: number) => void;
  /** The forwarded reference */
  nodeRef?: React.RefObject<HTMLDivElement> | null;
  style?: React.CSSProperties;
};

export const TimelineItem = memo(function TimelineItem({
  className,
  conversations: timelineConversations,
  status,
  isCurrent,
  onConversationSelect,
  nodeRef,
  ...otherProps
}: TimelineItemProps): JSX.Element {
  const handleOnDropdownToggle = useCallback((isOpen: boolean): void => {
    if (isOpen) {
      ampli.conversationTimelineItemOpened();
    }
  }, []);

  const rootClass = classnames(
    {
      [styles.root]: true,
      [styles.rootOpen]: status === 'open',
      [styles.rootFollowUp]:
        status === 'pending' || status === 'awaitingpending',
      [styles.rootCurrent]: isCurrent,
    },
    className,
  );

  return (
    <div {...otherProps} className={rootClass} ref={nodeRef}>
      <DropdownButton
        buttonProps={{
          className: styles.cluster,
        }}
        noArrow
        fixed
        onToggle={handleOnDropdownToggle}
        dropdown={
          <DropdownButtonContext.Consumer>
            {(props) => (
              <List className={styles.conversations}>
                {timelineConversations.map((item, index) => (
                  <TimelineItemRow
                    key={item.id}
                    index={index}
                    conversation={item}
                    onConversationSelect={onConversationSelect}
                    toggleDropdown={props.toggleDropdown}
                  />
                ))}
              </List>
            )}
          </DropdownButtonContext.Consumer>
        }
      >
        {timelineConversations.length > 1 && (
          <React.Fragment>{timelineConversations.length}</React.Fragment>
        )}
        {timelineConversations.length === 1 && (
          <TimelineIcon
            channel={timelineConversations[0].channel}
            isClosed={timelineConversations[0].status === 'closed'}
            hasFollowUp={timelineConversations[0].hasFollowUp}
          />
        )}
      </DropdownButton>
    </div>
  );
});
